import { Outlet } from 'react-router-dom';
import SmartSendNavigation from '~/apps/smartsend/components/onboarding/components/smart-send-navigation';
import { P2GButton, P2GIcon, SvgAdd, SvgAddCircle, useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import useSmartNav from '~/hooks/use-smart-nav';
import DesktopTitledLayout from './desktop-layout';
import { TranslationNamespaces } from '~/lib/constants';
import { useTranslation } from 'react-i18next';
import { sanitisedRoutesOfOrders } from '~/routes/groups/orders';
import { Suspense, useMemo } from 'react';
import { Add } from '~/apps/smartsend/components/smartsend/filter/Add';
import MobileLayout from './mobile-layout';
import { SettingsCache } from '~/lib/consts/settings-cache';

export default function Component() {
  const isXs = useP2GMediaQueryOnly('xs');
  const { currentPageRoute } = useSmartNav();
  const { t } = useTranslation(TranslationNamespaces.MYACCOUNT);
  const sanitisedRoutesOfOrdersMemo = useMemo(() => sanitisedRoutesOfOrders(), []);

  if (isXs) {
    return (
      <MobileLayout>
        <Outlet />
      </MobileLayout>
    );
  }

  return (
    <DesktopTitledLayout
      title={t('ORDERS_AREA_TITLE', { defaultValue: 'Orders' })}
      actions={
        <Add>
          {SettingsCache.settings.Features.includes('AddItemMenu') ? (
            <P2GButton variant="secondary" size="small" startIcon={<P2GIcon size="xs" children={<SvgAdd />} />}>
              {t('CREATE_ORDER_BUTTON', { defaultValue: 'Create Order' })}
            </P2GButton>
          ) : (
            <span style={{ cursor: 'pointer' }}>
              <P2GIcon size="sm" palette="primary">
                <SvgAddCircle />
              </P2GIcon>
            </span>
          )}
        </Add>
      }
    >
      <Suspense>
        <SmartSendNavigation currentPageRoute={currentPageRoute} routes={sanitisedRoutesOfOrdersMemo} />
      </Suspense>
      <Outlet />
    </DesktopTitledLayout>
  );
}

Component.displayName = 'My Orders';
